import React from 'react';
import styled from 'styled-components';

const Block = styled.div`
    width: 100%;
    max-width: 1504px;
    margin-right: auto;
    margin-left: auto;
    padding: 0 16px;
`;

const Container = ({ children }) => {
    return (
        <Block>{children}</Block>
    );
};

export default Container;
